import optimizeCloudinaryImg from "./optimize-cloudinary-img";

const BASE_URL = "https://res.cloudinary.com/cotribute/image/upload";

/**
 * Encodes text that can be used in cloudinary transformations.
 */
export const urlEncodeText = (text: string) => {
  return encodeURIComponent(
    encodeURIComponent(text).replace(/[!'()*]/g, function (c) {
      return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    })
  );
};

const generateCloudinaryUrl = (
  version: string,
  slug: string,
  options?: {
    type?: "avatar";
  }
) => {
  const rawImgUrl = `${BASE_URL}/${slug}`;
  const isAvatar = options?.type === "avatar";
  const width = isAvatar ? 50 : undefined;
  const height = isAvatar ? 50 : undefined;

  const optimizedImgUrl = optimizeCloudinaryImg(rawImgUrl, {
    width,
    height,
    version,
  });
  return optimizedImgUrl;
};

/**
 * Generates the url for the cloudinary transformation
 * Example: https://res.cloudinary.com/cotribute/image/upload/$title_!Please%2520come%2520to%2520the%2520event%2521!,$subtitle1_!From%252C!,$subtitle2_!John%2520Smith%2520and%2520the%2520kids!/t_event_invite_note_3_2subtitles/v1000/imaginary/event_invite_note_image03_image2.jpg
 *
 */
export const generateCloudinaryTransformation = ({
  transformationName,
  textVariables,
  baseImagePath,
}: {
  transformationName: string;
  textVariables: { name: string; value: string }[];
  baseImagePath: string;
}) => {
  let transformationVariables = "";

  if (textVariables) {
    textVariables.forEach((variable, index) => {
      transformationVariables += `$${variable.name}_!${urlEncodeText(
        variable.value
      )}!${index !== textVariables.length - 1 ? "," : ""}`;
    });
  }

  return `${BASE_URL}/${transformationVariables}/t_${transformationName}/v1000/${baseImagePath}`;
};

export default generateCloudinaryUrl;
